/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { campaignInterviewSettingsInputInterviewMeetingLocationTypeSchema } from './CampaignInterviewSettingsInputInterviewMeetingLocationTypeSchema'

export const campaignInterviewSettingsInputSchema = z.object({
	interviewDurationMinutes: z.number().nullable().optional(),
	interviewBookingWindowDays: z.number().nullable().optional(),
	interviewTokenExpiryDays: z.number().nullable().optional(),
	interviewMeetingLocationType: campaignInterviewSettingsInputInterviewMeetingLocationTypeSchema.nullable()
		.optional(),
	interviewMeetingLocationDetails: z.string().nullable().optional(),
	interviewDescription: z.string().nullable().optional(),
	interviewBookedStageId: z.string().nullable().optional(),
	interviewBookedStageType: z.string().nullable().optional(),
})

export type CampaignInterviewSettingsInputSchema = z.infer<typeof campaignInterviewSettingsInputSchema>
